/** The settings of the page "SEO": counters, verification codes, what search engines may index. */
import { baseApi } from '../baseApi';
import type { SeoSettings, SeoSettingsIn } from '../types';

export const seoApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getSeoSettings: build.query<SeoSettings, void>({
      query: () => '/seo/settings',
      providesTags: ['Seo'],
    }),
    saveSeoSettings: build.mutation<SeoSettings, SeoSettingsIn>({
      query: (body) => ({ url: '/seo/settings', method: 'PUT', body }),
      // A change is written to the journal of account management too.
      invalidatesTags: ['Seo', 'Audit'],
    }),
  }),
});

export const { useGetSeoSettingsQuery, useSaveSeoSettingsMutation } = seoApi;
